import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

const VisitReportChart = ({ visitReportGraph }) => {
  const [visitReportGraphBarGraph, setVisitReportGraphBarGraph] = useState({
    series: [
      {
        name: "No. of Visit",
        data: visitReportGraph || [],
      },
    ],

    options: {
      chart: {
        type: "bar",
        height: 350,
        stacked: true,
      },
      stroke: { width: 1, colors: ["#fff"] },
      plotOptions: {
        bar: { horizontal: true },
      },
      xaxis: {
        categories: ["Ongoing", "Completed"],
        labels: {
          style: {
            color: ["#103C5E99", "#103C5E99"],
            fontSize: "12px",
          },
        },
      },
      fill: { opacity: 1 },
      colors: ["#103C5E99", "#103C5E99"],
      legend: {
        position: "bottom",
        showForSingleSeries: true,
      },
    },
  });

  useEffect(() => {
    setVisitReportGraphBarGraph((prevChartData) => ({
      ...prevChartData,
      series: [{ data: visitReportGraph || [] }],
    }));
  }, [visitReportGraph]);

  return (
    <>
      <ReactApexChart
        options={visitReportGraphBarGraph.options}
        series={visitReportGraphBarGraph.series}
        type="bar"
        height={240}
      />
    </>
  );
};

export default VisitReportChart;
